import type {
    LibraryImage,
    LibraryVideo,
    LibraryDiagram,
} from '../type/product-gallery-types';

const isLibraryVideo = (
    data: LibraryImage | LibraryVideo | LibraryDiagram | null | undefined,
): data is LibraryVideo => {
    return !!data && (data as LibraryVideo).VideoID !== undefined;
};

export { isLibraryVideo };
